import * as React from 'react';
import { Button, Image, Flex, Loader, Form, List, Dialog, Popup, Text, Checkbox, Divider, FormInput, SplitButton } from '@fluentui/react-northstar';
import axios from 'axios';
import { CloseIcon } from '@fluentui/react-icons-northstar';
import { References } from '../helpers/References';
import { Helpers } from '../helpers/Helpers';
import EnvelopeIcon from "../Images/envelope.svg";
import PadLockIcon from "../Images/padlock.svg";
import MicrosoftIcon from "../Images/microsoft_logo.svg";
import KeyLockIcon from "../Images/key-lock.svg";
import NortonIcon from "../Images/norton.svg";
import GdprIcon from "../Images/gdpr.jpg";
import LexzurIcon from "../Images/lexzur-icon-white.png";
import CloudIcon from "../Images/cloud-mode.svg";
import ServerModeIcon from "../Images/server-mode.svg";
import ServerIcon from "../Images/server.svg";

var dialogMessage;
var dialogHeader = 'Information';
var ssoEnabled = true;
export default class LoginComponent extends React.Component<ILoginProps, ILoginState> {
    isMigrated: string;
    constructor(props) {
        super(props);
        this.state = {
            goToUrl: "",
            isCloud: true,
            dataCenter: serversOptions[0],
            serverUrl: "",
            email: "",
            password: "",
            isLoading: false,
            openDialog: false,
            openPopUp: false
        };
        this.handleSubmitForm = this.handleSubmitForm.bind(this);
        this.handleInputChanged = this.handleInputChanged.bind(this);
        this.handleLoginRequest = this.handleLoginRequest.bind(this);
        this.handelSelectedInstance = this.handelSelectedInstance.bind(this);
        this.saveCredentials = this.saveCredentials.bind(this);
        this.handleError = this.handleError.bind(this);
        this.isMigrated = '1';
    }
    saveCredentials(url, data) {
        let objToSend = {
            url: url,
            apiKey: data?.success?.data?.key,
            installationType: this.state.isCloud ? "on-cloud" : "on-server"
        }
        this.props.notifySuccess(objToSend);                                         
    }
    handleError(message) {
        dialogHeader = 'Warning';
        dialogMessage = JSON.stringify(message);
        this.setState({ openDialog: true, openPopUp: false, isLoading: false });
    }
    handleLoginRequest(url, username, password) {
        //Second Stage NEW
        let loginApi = url + References.loginApi;
        const formData = new FormData();
        formData.append('email', username);
        formData.append('userLogin', username);
        formData.append('password', password);
        formData.append('lang', 'english');
        var self = this;
        axios.post(loginApi, formData)
            .then(response => {
                if (response?.status === 200) {
                    const data = response.data;
                    let errorResponse = data.error;
                    if (errorResponse === '') {
                        self.saveCredentials(url, data);
                    } else {
                        this.handleError(errorResponse);
                    }
                } else {
                    this.handleError("Something Went Wrong");
                }
            })
            .catch(error => {                                
                this.handleError("Connection Error");
            })
    }
    handleSubmitForm(e) {
        //First Stage NEW
        e?.preventDefault();
        e?.stopPropagation();
        let username = this.state.email;
        if (this.state.isCloud) {
            this.setState({ isLoading: true });
            let dataCenterValue = this.state.dataCenter?.value;
            let signInCloud = References.newSignInCloudApi(dataCenterValue);
            const formData = new FormData();
            formData.append('email', username);
            formData.append('userLogin', username);
            formData.append('lang', 'english');
            var self = this;
            axios.post(signInCloud, formData)
                .then(response => {
                    this.setState({ isLoading: false });
                    if (response?.status === 200) {                        
                        const data = response.data;                       
                        let errorResponse = data.error;
                        if (!errorResponse) {
                            let instances = data.instances;
                            if (instances) {
                                self.setState({ goToUrl: data.goToURL });
                                if (Object.keys(instances)?.length > 1) {
                                    var items = [];
                                    Object.keys(instances).forEach(function (key) {
                                        items.push({
                                            header: instances[key],
                                            onClick: (e, props) => { self.handelSelectedInstance(key) }
                                        });
                                    });                                    
                                    dialogHeader = 'Select Instance';
                                    //More than one instance
                                    dialogMessage = <List items={items} selectable />;
                                    this.setState({ openPopUp: true });
                                }
                                else {
                                    self.handelSelectedInstance(Object.keys(instances)[0]);
                                }
                            }
                        } else {
                            this.handleError(errorResponse);
                        }
                    }
                    else {
                        this.handleError("Something went wrong!");
                    }
                })
                .catch(error => {                    
                    this.handleError(error);
                    this.setState({ isLoading: false });
                })
        } else {
            let url = this.state.serverUrl;
            let password = this.state.password;
            //check last character
            let lastChar = url.slice(-1);
            url = (lastChar !== "/") ? (url + "/") : url;
            this.handleLoginRequest(url, username, password);
        }
    }
    handelSelectedInstance(instanceId) {
        if (instanceId) {
            let url = this.state.goToUrl + "/" + instanceId + "/";
            let email = this.state.email;
            let password = this.state.password;
            this.handleLoginRequest(url, email, password);
        }
        else {
            this.setState({ isLoading: false });
        }
    }
    handleInputChanged(e, props) {
        switch (props.name) {
            case 'url': this.setState({ serverUrl: props.value }); break;
            case 'email': this.setState({ email: props.value }); break;
            case 'password': this.setState({ password: props.value }); break;
            default: break;
        }
    }
    render() {
        let appLogo = LexzurIcon;
        return (
            <div style={{height: '100%', width: '100%', backgroundColor: this.props.theme == 'default' ? '#fff' : (this.props.theme == 'dark' ? '#2d2c2c' : '#000') }}>
                <div style={{position: 'absolute', top: '0px', height: '200px', width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundImage: "url('/images/peopleGroup.jpg')"}}>
                    <Image src={appLogo} styles={{ width: '200px', marginTop: '-75px'}}/>
                </div>                                
                <Flex column hAlign='center' vAlign='center' styles={{ width: '85%', margin: 'auto', paddingTop: '20px' }} gap='gap.medium'>
                    <div style={{width: '100%',
                     borderTopLeftRadius: '50px',
                     borderTopRightRadius: '50px',
                     display: 'flex',                              
                     flexDirection: 'column',
                     justifyContent: 'center',                     
                     alignItems: 'center',
                     backgroundColor: 'white', position: 'absolute', top: '120px', padding: '0 15px'}}>
                        <Text style={{fontWeight: 500, marginTop: '10px'}} content={`Step 2: Sign in with ${Helpers.getAppName()}`}/>
                    <Flex inline gap='gap.large' hAlign='center' vAlign='stretch' styles={{ marginTop: '20px', width: '100%' }}>
                        <Button
                        icon={{
                            content: <Image src={CloudIcon}/>,
                            styles:{
                                width:'30px',
                                height: '30px'
                            }
                        }}
                        styles={{
                            backgroundColor: this.state.isCloud ? '#f6f6f6' : '#fff',
                            color: 'black'
                        }}
                        onClick={()=>this.setState({isCloud: true})}
                        content="Cloud"
                        />
                        <Button
                        icon={{
                            content: <Image src={ServerModeIcon}/>,
                            styles:{
                                width:'30px',
                                height: '30px'
                            }
                        }}
                        styles={{
                            backgroundColor: !this.state.isCloud ? '#f6f6f6' : '#fff',
                            color: 'black'
                        }}
                        onClick={()=>this.setState({isCloud: false})}
                        content="Server"
                        />
                    </Flex>
                    <div style={{height: '20px'}}></div>
                    <Form onSubmit={(e, props) => { this.handleSubmitForm(e) }}>
                        {this.state.isCloud ? <></> : <FormInput
                            iconPosition='start'
                            icon={{ content: <Image src={ServerIcon} />, styles: { marginLeft: '10px' } }}
                            clearable
                            inverted                            
                            fluid                            
                            placeholder='URL'
                            input={{ styles: { border: '0.5px solid lightGrey' } }}
                            name='url'
                            required
                            onChange={this.handleInputChanged} />}
                        <FormInput
                            iconPosition='start'
                            input={{ styles: { border: '0.5px solid lightGrey' } }}
                            icon={{ content: <Image src={EnvelopeIcon}/>, styles: { marginLeft: '10px' } }}
                            clearable inverted fluid
                            placeholder='Email'
                            name='email' required onChange={this.handleInputChanged} />                        
                            <FormInput
                                styles={{ width: '100%' }}
                                iconPosition='start'
                                successIndicator={null}
                                fluid
                                input={{ styles: { border: '0.5px solid lightGrey' } }}
                                icon={{ content: <Image src={PadLockIcon} />, styles: { marginLeft: '10px' } }}
                                type='password' inverted placeholder='Password' name='password' required onChange={this.handleInputChanged} />                        
                        {this.state.isCloud && <DataCentersButton onItemClicked={(event, data) => {
                            let index = data?.index;                                                                                    
                            this.setState({dataCenter: serversOptions[index]})
                            }} dataCenter={this.state.dataCenter}/>}
                        {this.state.isLoading ? <Loader /> : <Button
                            type='submit'
                            content='Sign in'
                            styles={{
                                color: 'white',
                                backgroundColor: '#155495',
                                margin: 'auto',
                                borderRadius: '35px',
                                height: "39px",
                                width: "90%"
                            }}
                        />}
                        {this.state.isCloud && <a style={{ margin: '0 auto', fontSize: '10px', marginTop: '-10px' }} target='_blank' href={References.newForgotPasswordURL(this.state.dataCenter?.value)}>Forgot Your password?</a>}
                    </Form>
                    <div style={{height: '20px'}}></div>
                    <Divider content="or" styles={{ width: '193px' }} size={1} />
                    <div style={{height: '20px'}}></div>
                    {ssoEnabled && <Button
                        icon={{ content: <Image src={MicrosoftIcon} /> }}
                        styles={{
                            borderRadius: '35px',
                            height: "39px",
                            width: "90%",
                            color: '#545252',
                            fontSize: 8,          
                            border: '1px solid #545252',                  
                            backgroundColor: '#fff',
                            paddingLeft: "20px",
                            paddingRight: "20px"
                        }}
                        content={{ content: <Text weight='light' content='Sign in using Azure AD' />, size: 'small' }} onClick={(e, props) => {
                            e.preventDefault();
                            e.stopPropagation();
                            const email = this.state.email?.trim() || '';
                            const url = this.state.serverUrl?.trim() || '';
                            const mode = this.state.isCloud ? 'cloud' : 'server';
                            const type = this.state.dataCenter?.value;        
                            window.location.href = `/sso?email=${email}&url=${encodeURIComponent(url)}&mode=${mode}&type=${type}&isAzure=true`;
                        }} />}
                        <div style={{height: '20px'}}></div>
                        {ssoEnabled && <Button
                        icon={{ content: <Image src={KeyLockIcon} /> }}
                        styles={{
                            borderRadius: '35px',
                            height: "39px",
                            width: "90%",
                            color: '#545252',
                            fontSize: 8,          
                            border: '1px solid #545252',                  
                            backgroundColor: '#fff',
                            paddingLeft: "20px",
                            paddingRight: "20px"
                        }}
                        content={{ content: <Text weight='light' content='Login with SSO' />, size: 'small' }} onClick={(e, props) => {
                            e.preventDefault();
                            e.stopPropagation();
                            const email = this.state.email?.trim() || '';
                            const url = this.state.serverUrl?.trim() || '';
                            const mode = this.state.isCloud ? 'cloud' : 'server';
                            const type = this.state.dataCenter?.value;        
                            window.location.href = `/sso?email=${email}&url=${encodeURIComponent(url)}&mode=${mode}&type=${type}&isAzure=false`;
                        }} />}
                        <div style={{ height: '20px' }}></div>
                    <Button text content={`New to ${Helpers.getAppName()}? Sign up`} onClick={(e, props) => {
                        e.preventDefault();
                        e.stopPropagation();
                        window.open(References.newSignupURL(this.state.dataCenter?.value));
                    }} />                        
                        <Text content={<div style={{ textAlign: 'center' }}>
                            Learn more about our <a target='_blank' href='termsconditions'>Security</a> & <a target='_blank' href='/privacypolicy'>Privacy Policy</a>
                        </div>
                        }
                            styles={{ marginTop: '25px' }} />
                            <Flex gap='gap.medium'>
                            <Image src={NortonIcon} />                                                    
                            <Image styles={{width: '40px'}} src={GdprIcon} />                        
                            </Flex>                        
                    </div>
                    <Dialog
                        styles={{ width: '80%', overFlow: 'auto' }}
                        open={this.state.openDialog}
                        header={dialogHeader}
                        content={dialogMessage}
                        cancelButton="Cancel"
                        onCancel={() => { this.setState({ openDialog: false, isLoading: false }) }}
                    />
                    <Popup
                        open={this.state.openPopUp}
                        content={{
                            content: <Flex column gap='gap.medium'>
                                <Flex hAlign='center' vAlign='stretch'>
                                    <Text size='large' content='Choose an Instance' />
                                    <Flex.Item push>
                                        <Button icon={<CloseIcon />} onClick={(event) => {
                                            event.preventDefault();
                                            event.stopPropagation();
                                            this.setState({ openPopUp: false, isLoading: false });
                                        }} iconOnly title="Close" />
                                    </Flex.Item>
                                </Flex>
                                <Flex>
                                    {dialogMessage}
                                </Flex>
                            </Flex>
                        }}
                        trapFocus
                    />
                </Flex>
            </div>
        );
    }
}
export function DataCentersButton(props) {    
    return (
        <>
            <SplitButton
                menu={serversOptions.map(option => {
                    return({
                        key: option.value,
                        content: option.fullName + ` (${option.name})`
                    })
                })}
                button={{
                    content: `Data Center (${props.dataCenter?.name})`,
                    'aria-roledescription': 'splitbutton',
                    'aria-describedby': 'instruction-message',
                }}
                size="small"
                toggleButton={{
                    'aria-label': 'expand options menu',
                }}
                onMainButtonClick={(event)=>{
                    event.preventDefault();
                    event.stopPropagation();
                }}
                onClick={(event)=>{
                    event.preventDefault();
                    event.stopPropagation();
                }}
                onMenuItemClick={props.onItemClicked}                
            />            
        </>
    )
}
export interface DataCenterData {
    id: number,
    name: string,
    value: string,
    fullName: string
}
export const serversOptions : DataCenterData[] = [
    {
        id: 1,
        name: "FR",
        fullName: 'France',
        value: 'site'
    },
    {
        id: 2,
        name: "KSA",
        fullName: 'Saudi Arabia',
        value: 'ksa'
    },
    {
        id: 3,
        name: "UAE",
        fullName: "United Arab Emirates",
        value: 'ae'
    }
]
interface ILoginProps {
    notifySuccess(any);
    theme: string;
}

interface ILoginState {
    goToUrl: string;
    isCloud: boolean;
    serverUrl: string;
    email: string;
    password: string;
    isLoading: boolean;
    openDialog: boolean;
    openPopUp: boolean;
    dataCenter: DataCenterData
}